import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useSalaryRegulCotisSchema = ({ store }) => {
    const { t } = useTranslation();
    const requiredMessage = t('yup.validators.required');

    return Yup.object().shape({
        salaryRappelS3201: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.string(),
                    startDate: Yup.date()
                        .nullable()
                        .test('custom-validation-start_date', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { end_date, amount } = parent;
                            const hasValue = !!end_date || !!amount;
                            if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                            return true;
                        }),
                    endDate: Yup.date()
                        .nullable()
                        .test('custom-validation-end_date', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { start_date, amount } = parent;
                            const hasValue = !!start_date || !!amount;
                            if (hasValue && !value) return createError({ message: requiredMessage, path: this.path });
                            return true;
                        }),
                    amount: Yup.string().nullable(),
                }),
            )
            .required(),
        interruptionActivityS3201: Yup.array()
            .of(
                Yup.object({
                    id: Yup.string().required(requiredMessage),
                    period: Yup.string()
                        .nullable()
                        .test('all-or-none', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { amount, reason, realH, completH, restoredSalary } = parent;
                            const fields = [amount, reason, realH, completH, restoredSalary];
                            const hasValue = fields.some((field) => !!field);
                            if (hasValue && !value) {
                                return createError({ message: requiredMessage, path: this.path });
                            }
                            return true;
                        })
                        .test('salaryBase.salaire.id-must-exist', 'SalaryBase salaire must exist', function (value) {
                            if (!value) return true;
                            const salaryBase = store.salaryBaseS3201.find((o) => o.id === value);
                            return !!salaryBase;
                        }),
                    amount: Yup.string().nullable(),
                    reason: Yup.string()
                        .nullable()
                        .test('all-or-none', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { amount, period, realH, completH, restoredSalary } = parent;
                            const fields = [amount, period, realH, completH, restoredSalary];
                            const hasValue = fields.some((field) => !!field);
                            if (hasValue && !value) {
                                return createError({ message: requiredMessage, path: this.path });
                            }
                            return true;
                        }),
                    realH: Yup.string()
                        .nullable()
                        .test('all-or-none', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { amount, period, reason, completH, restoredSalary } = parent;
                            const fields = [amount, period, reason, completH, restoredSalary];
                            const hasValue = fields.some((field) => !!field);

                            if (hasValue && !value) {
                                return createError({ message: requiredMessage, path: this.path });
                            }
                            return true;
                        }),
                    completH: Yup.string()
                        .nullable()
                        .test('all-or-none', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { amount, period, realH, reason, restoredSalary } = parent;
                            const fields = [amount, period, realH, reason, restoredSalary];
                            const hasValue = fields.some((field) => !!field);
                            if (hasValue && !value) {
                                return createError({ message: requiredMessage, path: this.path });
                            }
                            return true;
                        })
                        .test('is-greater-than-realH', 'completH must be greater than realH', function (value) {
                            if (!value) return true;
                            const { realH } = this.parent;
                            const completH = parseFloat(String(value).replace(',', '.'));
                            const realHFloat = parseFloat(String(realH).replace(',', '.'));

                            return completH > realHFloat;
                        }),
                    restoredSalary: Yup.string()
                        .nullable()
                        .test('all-or-none', requiredMessage, function (value) {
                            const { parent, createError } = this;
                            const { amount, period, realH, completH, reason } = parent;
                            const fields = [amount, period, realH, completH, reason];
                            const hasValue = fields.some((field) => !!field);
                            if (hasValue && !value) {
                                return createError({ message: requiredMessage, path: this.path });
                            }
                            return true;
                        })
                        .test('is-greater-than-store-amount', 'restoredSalary must be greater than store.amount', function (value) {
                            if (!value) return true;
                            const { period } = this.parent;
                            const salaryBase = store.salaryBaseS3201.find((o) => o.id === period);
                            return Number(value) > Number(salaryBase?.amount);
                        }),
                }),
            )
            .required(),
    });
};
